import { useRef } from "react";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { AppDialog } from "../../components/AppDialog";
import { AppDialogHeader } from "../../components/AppDialogHeader";
import { showToast } from "../../../toast";

const MAX_AVATAR_SIZE = 5 * 1024 * 1024; // matches the server's 5MB avatar limit

// "Take Photo" and "Choose from Library" are two real, distinct inputs
// (the second has `capture="environment"`, which mobile browsers honor to
// open the camera directly - desktop browsers just ignore it and show the
// normal file picker) rather than one input dressed up as two options.
export function ChangePhotoActionSheet({ onClose, onPicked }: { onClose: () => void; onPicked: (file: File) => void }) {
  const libraryInputRef = useRef<HTMLInputElement>(null);
  const cameraInputRef = useRef<HTMLInputElement>(null);

  function handleFile(e: React.ChangeEvent<HTMLInputElement>): void {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > MAX_AVATAR_SIZE) {
      showToast("Image too large (max 5MB).", "error");
      return;
    }
    onPicked(file);
  }

  return (
    <AppDialog open onClose={onClose} maxWidth="xs" fullWidth>
      <AppDialogHeader icon="bi-camera" title="Profile photo" onBack={onClose} />
      <DialogContent sx={{ pt: 2 }}>
        <input
          ref={cameraInputRef}
          type="file"
          accept="image/jpeg,image/jpg,image/png,image/webp,image/gif"
          capture="environment"
          hidden
          onChange={handleFile}
        />
        <input
          ref={libraryInputRef}
          type="file"
          accept="image/jpeg,image/jpg,image/png,image/webp,image/gif"
          hidden
          onChange={handleFile}
        />
        <Box sx={{ display: "grid", gap: 1 }}>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => cameraInputRef.current?.click()}
            sx={{ justifyContent: "flex-start" }}
          >
            <i className="bi bi-camera me-2" aria-hidden="true" style={{ marginRight: 10 }} />
            Take photo
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => libraryInputRef.current?.click()}
            sx={{ justifyContent: "flex-start" }}
          >
            <i className="bi bi-images me-2" aria-hidden="true" style={{ marginRight: 10 }} />
            Choose from library
          </Button>
          <Button onClick={onClose} sx={{ mt: 1 }}>
            Cancel
          </Button>
        </Box>
      </DialogContent>
    </AppDialog>
  );
}
